import React, { useEffect, useReducer, useState } from "react";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import Toaster from "../../shared/Toaster/Toaster";
import "./MySchedulePage.scss";
import MyScheduleSummaryBlock from "./MyScheduleSummaryBlock";
import "./MyScheduleSummaryBlock.scss";
import translate from "../../../i18n/translate";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import { productList } from "../../../globalConstants";

const MySchedulePage: React.FC = () => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  let licenseList: any;
  let [license, setLicense] = useState([{ courseId:0, status:"", courseName: "", imageURL:""}]);
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [licenseInfo, setLicenseInfo] = useState([
    { productId: "", productName: "", licenseId: "", startDate: "", endDate: "" },
  ]);
  let edgeId: number;
  let username: string;
  sessionStorage.setItem("RescheduleChkBox", "False");
  const [status, setstatus] = useState(0);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });
  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  const getTMSListInfo = async () => {
    const uuId = allInfo.common.luuId;
    if(!!!allInfo.tmsCourses.isLoading){     
        await dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    } 
  };

  const getLearnerInfo =  (courseDataFromAPI : any) => {
    if(!! allInfo.peopleInformation.data){
      const data = allInfo.peopleInformation.data.getpeopleInformation;
        licenseList = data.license;
        edgeId = data.edgeUid;
        username = data.username;
        let includedIds = JSON.parse(process.env.REACT_APP_BLENDED_USERS || "") || [{}];
        const filteredArray = data.license.filter((product: any) => {
          return includedIds.indexOf(parseInt(product["productId"])) > -1 && product["active"] == 1;
        });
        filteredArray.length > 0 ? sessionStorage.setItem("isScheduleRequired", "true") : sessionStorage.setItem("isScheduleRequired", "false");
    }
    else {
      if(!!!allInfo.peopleInformation.data){
         dispatch(allActions.peopleInformationActions.getStorePeopleInfo(allInfo.common.lgId));
      }
    }
        if (licenseList && licenseList.length > 0) {
          setLicenseInfo(licenseList);
        }
             const courseData : any =  courseDataFromAPI != null ? courseDataFromAPI.getTMSGetCourse : null;
              if (courseData != null && courseData.length > 0) {
           let includeArr = JSON.parse(process.env.REACT_APP_BLENDED_PRODUCTS_FILTER || "").map((value: string) => value.toLowerCase()) || [{}];
           let textReplace = JSON.parse(process.env.REACT_APP_BLENDED_PRODUCT_NAME || "") || [{}];
            let finFilteredArr : any = courseData.filter((course: any) => {
            return  includeArr.filter((value: string) => value.trim().indexOf(course.courseName.toLowerCase())!==-1)
          
                 });
             finFilteredArr = finFilteredArr.map((item: any) => 
            Object.assign({}, item, {imageURL:""})
             )
               for (let i=0; i< finFilteredArr.length; i ++)
               {
                 for(let j=0; j<includeArr.length; j++ )
                 {
                  if( (!!finFilteredArr[i].courseName) && finFilteredArr[i].courseName.toLowerCase().indexOf(includeArr[j])!==-1)                {
                    finFilteredArr[i].courseName = textReplace[j];
                    const searchRegExp = /\s/g;
                    finFilteredArr[i].imageURL = textReplace[j].trim().toLowerCase().replace(searchRegExp,'-');
                   }
                 }
               }
                  setLicense([...finFilteredArr]);
              }
              setLoaderFlag(false);
  };


  useEffect(() => {
        if(!!!allInfo.tmsCourses.isLoading && !!!allInfo.tmsCourses.data && !!!allInfo.tmsCourses.isFailed ){
          getTMSListInfo();
        }
        else if (!!allInfo.tmsCourses.isFailed)
        {
          setstatus(404);
          setLoaderFlag(false);
        }
         if(!!allInfo.tmsCourses.data)
         getLearnerInfo(allInfo.tmsCourses.data);   
  }, [allInfo.tmsCourses]);

  const OpenProductSession = (product: string, courseID : number) => {
    let licenseId: any = 0;
    licenseInfo.forEach((element) => {
      if (element.productName === product) {
        licenseId = element.licenseId;
      }
    });
    let productDetails = productList.find(x => x.productName.toLowerCase() === product.toLowerCase());
    history.push({ pathname: `/schedule/${courseID}`, state: { productId : productDetails?.productId }});
  };
  return (typeof (status) === 'undefined' || status === null || status === 0) && sessionStorage.getItem("isScheduleRequired")==="true" ? (
    <div className="productSchedule-Container">
      <h2>{translate("myschedule_schedule")}</h2>
      <div className="productSchedule-wrapper">
      {status === 0 && license &&
        license.length > 0 &&
        Object.keys(license[0]).length > 0 &&
        license
        .map((pd: any) => {
          return (
            <MyScheduleSummaryBlock
              Heading=""
              Description={pd.courseName}
              IsAddButtonRequired={false}
              HeaderTextColor="finished-sessions"
              buttonClick={() => OpenProductSession(pd.courseName, pd.courseId)}
              imageURL = {"Product_Illustrations/"+ pd.imageURL +".svg"}
              Navigation={true}
              PaperOnClick={() => OpenProductSession(pd.courseName, pd.courseId)} 
              courseStatus = {pd.status}
            />
          );
        })}
      {(status > 0 && <ErrorPage status={status} />)}
      <Loader showLoader={loaderFlag} />
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      </div>
    </div>
  ) : (< React.Fragment > <ErrorPage status={status} />
    <Loader showLoader={loaderFlag} />
    <Toaster
      open={toastOptions.toastOpen}
      severity={toastOptions.toastSeverity}
      toasterClosed={toasterHandle}
      messageKey={toastOptions.toastMessageKey}
    />
  </React.Fragment >);
};

export default MySchedulePage;
